module.exports = __webpack_public_path__ + "img/intro_final_lazy.8e65cd7b.jpg";